module.exports = __webpack_public_path__ + "assets/logo.png";


//////////////////
// WEBPACK FOOTER
// ./clients/swmh-kbb/images/logo.png
// module id = 445
// module chunks = 1